module.exports = __webpack_public_path__ + "img/ico-office.7033bf3b.svg";